import React from "react";

export const Subscriptions = () => {
  return (
    <p className="flex text-center justify-center align-center">
      Subscriptions are currently unavailable
    </p>
  );
};
